import React, { useState, useEffect } from 'react';
import { Link, animateScroll as scroll } from 'react-scroll';
import Logo from '../../assets/image/middleLogo.png';
import socialIconOne from '../../assets/image/fb.jpeg';
import socialIconTwo from '../../assets/image/linkedIn.jpeg';
import socialIconThree from '../../assets/image/insta.jpeg';
import socialIconFour from '../../assets/image/youtube.avif';
import socialIconFive from '../../assets/image/twitter.png';
import { FaPhone } from "react-icons/fa6";
import { FaEnvelope } from "react-icons/fa6";


function Header() {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleScroll = () => {
    if (window.scrollY > 150) {
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  };
  return (
    <div className='headerWrap'>
      <div className="logoOuterWrap">
        <div className="logoWrap">
          <div className="logo"><img src={Logo} alt="logo" /></div>
          <div className="slogan">
            <h4 className='merienda-heading'>Parishrama Divyang Sports Academy</h4>
            <h6 className='philosopher-regular-italic'>A Canopy for Divyang Sports and Skills</h6>
          </div>
        </div>
        <div className="quickInfoWrap">
            <div className="conctWrap">
              <ul>
                <li><span><FaPhone className='callIcon' /><a href="tel:+917975808067"> +91-7975808067</a></span><span>&nbsp;&nbsp;&nbsp;<FaPhone className='callIcon' /><a href="tel:+9197392 75828"> +91-9739275828</a></span></li>
                <li><span><FaEnvelope className='emailIcon' /><a href="mailto:parishramasportsacademy23@gmail.com"> parishramasportsacademy23@gmail.com</a></span></li>
              </ul>
            </div>
            <div className="socialMediaWrap">
              <ul>
                <li><a href="https://www.facebook.com/people/Parishrama-Divyang-Sports-academy/100093854139506/?rdid=xSPF9nM1amCe96JF&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F19xKpvE6TB%2F" target="_blank"><img src={socialIconOne} alt="icon" className="socialIcon" /></a></li>
                <li><a href="https://www.linkedin.com/authwall?trk=bf&trkInfo=AQH2HNuBrTnKegAAAZWQQlxYHw32fVjieUIm4lJxsD-qeKvS-lhdOywmuwEfH7xnsRJuOEDjT2cNSswd292qXIAgceqI3I-Qy2vXwF46LAcsqellLdZ8HbVEVjxmVotpcicvbog=&original_referer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fin%2Fparishrama-divyang-sports-academy-91b86427b%3Futm_source%3Dshare%26utm_campaign%3Dshare_via%26utm_content%3Dprofile%26utm_medium%3Dandroid_app" target="_blank"><img src={socialIconTwo} alt="icon" className="socialIcon" /></a></li>
                <li><a href="https://www.instagram.com/parishramadivyangsportsacademy/?igsh=MzlwYmp6bnRjcHQ5#" target="_blank"><img src={socialIconThree} alt="icon" className="socialIcon" /></a></li>
                <li><a href="https://www.youtube.com/@teamparishrama" target="_blank"><img src={socialIconFour} alt="icon" className="socialIcon" /></a></li>
                <li><a href="https://x.com/i/flow/login?redirect_after_login=%2FParishrama23" target="_blank"><img src={socialIconFive} alt="icon" className="socialIcon" /></a></li>
              </ul>
            </div>
        </div>
      </div>
      <div className="menuWrap">
        
      <nav className={isSticky ? 'sticky' : ''}>
        <Link activeClass="active" to="section1" spy={true} smooth={true} offset={-70} duration={500}>HOME</Link>
        <Link to="section2" spy={true} smooth={true} offset={-50} duration={500}>ABOUT</Link>
        <Link to="section3" spy={true} smooth={true} offset={-50} duration={500}>UPCOMING EVENTS</Link>
        <Link to="section4" spy={true} smooth={true} offset={-50} duration={500}>ACHIEVEMENT</Link>
        <Link to="section5" spy={true} smooth={true} offset={-50} duration={500}>GALLERY</Link>
        <Link to="section6" spy={true} smooth={true} offset={-50} duration={500}>PARTNERS</Link>
        <Link to="section7" spy={true} smooth={true} offset={-50} duration={500}>DONATION</Link>
        <Link to="section8" spy={true} smooth={true} offset={-50} duration={500}>CONTACT</Link>
          <span></span>
        </nav>
      </div>
    </div>
  )
}

export default Header




